export const environment = {
  production: true,
  apiUrl: 'https://api.aramarkpay.com.ar',
};
